import { useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { ChangeProposalsPanel } from './ChangeProposalsPanel'

/**
 * Fereastra Change Proposals, trasa din dreapta ca sertarul de chat -
 * `_partials/change_drawer.php` + `public/js/change_drawer.js`.
 *
 * Corpul e acelasi panou ca pagina `/change`, deci e rupt de chenarul paginii
 * - nimic din pagina de sub el nu-l poate bloca. Foaia e a portalului
 * (`public/css/change_drawer.css`, in PORTAL_STYLES): sertarul sta intre
 * antetul si subsolul fixe, nu peste ele.
 *
 * Se deschide din antet (Settings > Change Proposals) sau de oriunde cu
 * `onOpen`; Escape si overlay-ul il inchid, ca in portal.
 */
export function ChangeDrawer({ open, onClose }: { open: boolean; onClose: () => void }) {
  const client = useQueryClient()

  useEffect(() => {
    if (!open) return
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', onKey)
    return () => document.removeEventListener('keydown', onKey)
  }, [open, onClose])

  return (
    <>
      <div
        id="odChangeOverlay"
        className={'od-change-overlay' + (open ? ' is-open' : '')}
        aria-hidden={!open}
        onClick={onClose}
      ></div>

      <aside id="odChangeDrawer" className={'od-change-drawer' + (open ? ' is-open' : '')} aria-hidden={!open}>
        <div className="od-change-head">
          <strong>Change Proposals</strong>
          <button
            type="button"
            className="od-change-refresh"
            title="Reload"
            onClick={() => void client.invalidateQueries({ queryKey: ['changes'] })}
          >
            &#8635; Refresh
          </button>
          <button type="button" className="od-change-close" aria-label="Close" onClick={onClose}>
            &times;
          </button>
        </div>
        <div className="od-change-body" id="odChangeBody">
          {/* Se monteaza numai deschis: asa fiecare deschidere cere panoul din nou
              (si reconciliaza valurile pe server), ca `loadPanel()` din portal. */}
          {open && <ChangeProposalsPanel />}
        </div>
      </aside>
    </>
  )
}
